import React from 'react';
import image1 from '../assets/images/Remediation of site.jpeg';
import image2 from '../assets/images/pipelines.jpg';
import image3 from '../assets/images/oil-spill.jpeg';
import { useNavigate } from 'react-router-dom';
import { NonAuthRoutes } from '../url';
import greenImage from '../assets/dImages/Hi-Res/green.jpeg';
import oilAndGas from '../assets/dImages/Hi-Res/pexels-angelica-reyn-8420517.jpg';
import CyberSecurity from '../assets/images/cybersecurity.jpg';

const Support = () => {
    const navigate = useNavigate();

  const cardData = [
    {
      title: 'Value for Money Audit',
      image: image1,
      description: 'Our company conducted a comprehensive value for money audit for a leading oil and gas corporation. We assessed their operational processes, identified areas of inefficiency, and recommended cost-saving measures that resulted in significant financial benefits for the client.',
    },
    {
        image: image2,
        title: 'Setting up Management System',
      description: 'We assisted a prominent energy company in setting up robust management systems to streamline their operations. Our team implemented industry best practices, including quality management, health and safety protocols, and environmental compliance, resulting in improved efficiency, reduced risks, and enhanced regulatory compliance',
    },
    {
        image: image3,
        title: 'Provision of Oil Spill Response service',
      description: ' In collaboration with a major oil company, we provided prompt and effective spill response services to mitigate environmental damage and ensure regulatory compliance. Our experienced team executed a well-coordinated response plan, minimizing the impact of the spill and protecting the surrounding ecosystem.'
    },

  ];

  const sections = [
    {
      link: NonAuthRoutes.GreenEnergy,
      image: oilAndGas,
      title: "OIL AND GAS",
      content:"Our oil and gas services provide comprehensive solutions for exploration, drilling, production, and distribution. We leverage industry expertise and advanced technologies to maximize efficiency and optimize operations in this ever-evolving sector. From upstream to downstream, we ensure safe and sustainable energy extraction.",
    },
    {
      link: NonAuthRoutes.GreenEnergy,
      image: greenImage,
      title: "GREEN ENERGY SERVICES",
      content: "Embracing sustainability, our green energy solutions focus on harnessing renewable resources to generate power. We offer expertise in solar, wind, hydro, and other eco-friendly energy sources. By promoting clean energy production and reducing carbon footprint, we strive to create a greener future for generations to come.",
    },
    {
      link: NonAuthRoutes.CyberSecurity,
      image:CyberSecurity,
      title: "CYBER SECURITY",
      content: " Protecting your digital assets is paramount in today's interconnected world. Our cybersecurity services offer end-to-end solutions to safeguard your sensitive data, networks, and systems from cyber threats. Our experienced team utilizes advanced technologies and best practices to ensure robust defense mechanisms and proactive risk management.",
    },
  ];

  return (
    <div name="support" className="w-full mt-24">
      <h3 className="text-[32px] md:text-5xl font-bold py-6 text-center text-diakrino-orange mb-10">Our Services</h3>
 <div>
    {sections.map((section, index) => {
      const isEvenIndex = index % 2 === 0;
      return (
        <div key={index} className="flex flex-col-reverse md:flex-row md:items-center mb-12 max-w-[1240px] mx-auto">
          {isEvenIndex ? (
            <div className="md:w-1/2 px-4 mb-8">
              <img src={section.image} alt={section.title} className="rounded-lg" loading="lazy"
 />
            </div>
          ) : null}

          <div className="md:w-1/2 px-4 mb-8">
            <div>
              <h2 className="text-2xl font-semibold mb-4">{section.title}</h2>
              <p>{section.content}</p>
            </div>
            <button className="button py-3 px-6 sm:w-[60] my-4" onClick={() => navigate(section.link)}>
              Learn More...
            </button>
          </div>

          {!isEvenIndex ? (
            <div className="md:w-1/2 px-4 mb-8">
              <img src={section.image} alt={section.title} className="rounded-lg" loading="lazy"
/>
            </div>
          ) : null}
        </div>
      );
    })}
  </div>
      <div className="w-full h-[700px] bg-gray-900/90 absolute ">
        <img className="w-full h-full object-cover mix-blend-overlay" src={image1} alt="/"/>
      </div>

      <div className="max-w-[1240px] mx-auto text-white relative">
        <div className="px-4 py-12">
          <h3 className="text-[32px] md:text-5xl font-bold py-6 text-center text-diakrino-orange">Past Projects</h3>
          <p className="py-4 text-[16px] md:text-3xl text-slate-300">
          Explore our notable past projects, where we have demonstrated our proficiency in delivering innovative solutions and exceptional outcomes
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 relative gap-x-8 gap-y-16 px-4 pt-12 sm:pt-20 text-black leading-[30px]">
          {cardData.map((card, index) => (
            <div key={index} className="bg-white rounded-xl shadow-2xl">
              <div className="p-8">
                <img src={card.image} alt='pictures'/>
                <h2 className="font-bold text-diakrino-orange my-6 text-[24px] text-center   ">{card.title}</h2>
                <p className='text-justify	'>{card.description}</p>

              </div>
              <div className="bg-slate-100 pl-8 py-4">
               {/* <button className="flex items-center text-indigo-600" onClick={() => navigate(NonAuthRoutes.Contact)} >
                  Contact Us <ArrowSmRightIcon className="w-5 ml-2" />
          </button>*/}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Support;
